export function NwHeader() {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
        <img src="/newwestern-black.svg" alt="New Western" className="h-8" />
        <div className="text-right">
          <p className="text-sm font-semibold tracking-wide uppercase" style={{ color: 'var(--color-nw-charcoal)' }}>
            Funding Application
          </p>
          <p className="text-xs text-gray-400">Powered by Quick Draw Funding</p>
        </div>
      </div>
    </header>
  );
}
